<template>
  <q-td :props="props" :key="colKey">
    <ams-format-date
      :date="props.row.updatedAt"
      dateString="DD.MM.YYYY HH:mm"
    />
  </q-td>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
  },
});
</script>
